module.exports = __webpack_public_path__ + "static/media/41.2673935b.png";